// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
export class WarningSett
{
    constructor()
    {
        this.WarnIfWrongOrder = true;
        this.WarnIfIdenticalSubsequentOrderIsPlaced = false;
        this.WarnIfIdenticalOrderTime = 3;
        this.WarnIfQtyToCloseMoreThanMaxLot = false;
        this.OvernightMarginNotificationMessage = true;
    }

    needToShowWarning (confirmData)
    {                                        // some warnings ignore the warnOnWrongOrder setting #110331
        return this.WarnIfWrongOrder || (confirmData && confirmData.needShowWarningForce)
    }
}